import { PhaseLobby } from '@/api/generated/game';
import { ConnectedLobby } from '@/screens/lobby/ConnectedLobby';
import { PreRoomLobby } from '@/screens/lobby/PreRoomLobby';
import { useGame } from '@/store/game';

/**
 * 02 · Настройка партии. Шире, чем в макете: макет рисует только
 * hotseat-состав, здесь ещё выбор режима и multi (создать/войти по коду).
 * Тумблеров четырёх колод из макета нет — в контракте нет поля, которое бы
 * их описывало; выбор пака (`deckVersion`) — это другой раздел, DeckPicker.
 *
 * `state` появляется, как только комната создана или найдена по коду
 * (транспорт прислал hello) — до этого момента показываем сценарий выбора
 * и создания, после — общий экран ожидания с живым списком из PublicState.
 */
export function LobbyScreen() {
  const state = useGame((s) => s.state);

  if (state && state.phase === PhaseLobby) return <ConnectedLobby />;
  return <PreRoomLobby />;
}
